<template>
  <div class="fund-page" v-if="fund">
    <div class="top-fund">
      <div class="left">
        <h2>{{__('Fund')}}</h2>
        <div class="wallets">
          <p class="text">{{__('Choose from which balance to withdraw money to the fund')}}</p>
          <ul>
            <li v-on:click="updateWallet(1)" :class="(form.wallet== 1) ? 'active' : ''">
              <div class="img">
                <span>
                  <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.8323 0.625C21.6905 0.625 24.8288 3.76333 24.8288 7.62267V15.9958C24.8288 19.854 21.6905 22.9935 17.8323 22.9935H7.74767C3.8895 22.9935 0.75 19.854 0.75 15.9958V7.62267C0.75 3.76333 3.8895 0.625 7.74767 0.625H17.8323ZM17.8323 2.375H7.74767C4.85433 2.375 2.5 4.72933 2.5 7.62267V15.9958C2.5 18.8892 4.85433 21.2435 7.74767 21.2435H17.8323C20.7257 21.2435 23.0788 18.8892 23.0788 15.9958V15.6692L19.2313 15.6699C17.0181 15.6699 15.2168 13.8697 15.2156 11.6577C15.2156 9.44337 17.017 7.64203 19.2313 7.64087L23.0788 7.64017V7.62267C23.0788 4.72933 20.7257 2.375 17.8323 2.375ZM23.0788 9.39017L19.2313 9.39087C17.9818 9.39203 16.9656 10.4082 16.9656 11.6565C16.9656 12.9037 17.983 13.9199 19.2313 13.9199L23.0788 13.9192V9.39017ZM19.7652 10.7092C20.2482 10.7092 20.6402 11.1012 20.6402 11.5842C20.6402 12.0672 20.2482 12.4592 19.7652 12.4592H19.4012C18.9182 12.4592 18.5262 12.0672 18.5262 11.5842C18.5262 11.1012 18.9182 10.7092 19.4012 10.7092H19.7652ZM13.2158 5.91945C13.6988 5.91945 14.0908 6.31145 14.0908 6.79445C14.0908 7.27745 13.6988 7.66945 13.2158 7.66945H6.917C6.434 7.66945 6.042 7.27745 6.042 6.79445C6.042 6.31145 6.434 5.91945 6.917 5.91945H13.2158Z"/>
                  </svg>
                </span>
              </div>
              <div class="block">
                <p>{{__('USDT Balance')}}</p>
                <span>{{$primNum(fund.balance)}}</span>
              </div>
            </li>
            <li v-on:click="updateWallet(3)" :class="(form.wallet== 3) ? 'active' : ''">
              <div class="img">
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.7393 19.5782C14.0555 20.0385 14.442 20.4329 14.9339 20.7617C15.6367 21.222 16.4448 21.485 17.3586 21.485C19.3263 21.485 20.9428 20.2357 21.4348 18.559C21.5402 18.2302 21.5752 17.9016 21.5752 17.54V17.1783C21.3995 15.4687 20.0994 14.0879 18.4129 13.6935C18.0614 13.6275 17.7101 13.5947 17.3586 13.5947C17.2182 13.5947 17.0424 13.5947 16.9017 13.6275C16.8314 13.6275 16.7613 13.6275 16.6909 13.6603C14.6881 13.9235 13.142 15.5673 13.142 17.5397C13.142 18.263 13.3527 18.9863 13.7393 19.5782ZM12.2284 19.6768C11.9122 19.0194 11.7365 18.296 11.7365 17.54C11.7365 15.1401 13.4584 13.1347 15.7774 12.4772C15.9178 12.4444 16.0936 12.4114 16.2693 12.3786C15.707 11.5239 15.0393 10.8662 14.3016 10.3732C13.9501 10.1101 13.5635 9.91291 13.177 9.78151C12.7201 9.61708 12.2985 9.51847 11.8769 9.51847C11.5254 9.51847 11.1389 9.58429 10.7877 9.71569C10.4011 9.8471 10.0146 10.0115 9.62808 10.2746C7.83605 11.3923 6.18452 13.7924 6.18452 17.0799C6.18452 17.3757 6.21957 17.6388 6.36026 17.869C6.46566 18.132 6.64141 18.3292 6.8522 18.5264C7.09829 18.7237 7.41448 18.9209 7.80101 19.0525C8.855 19.5123 10.5769 19.7095 12.2285 19.6767L12.2284 19.6768ZM24 15.5015C24 16.3562 23.6135 17.0795 23.0161 17.6714L22.9811 17.7042C22.8757 20.5315 20.3807 22.8 17.3587 22.8C15.6721 22.8 14.161 22.1095 13.1421 21.0248C10.3662 21.2551 7.23884 20.7946 5.83315 19.5124C5.6927 19.381 5.58706 19.2494 5.44661 19.118C3.61932 18.9863 1.89763 18.5261 0.983893 17.6714C0.351516 17.0797 0 16.3564 0 15.5015C0 13.7263 0.632378 11.7536 1.68661 10.2412C2.2136 9.48513 2.81118 8.89324 3.47864 8.43298C3.58404 8.33437 3.61909 8.20273 3.65438 8.07133C3.68943 7.87411 3.61933 7.64387 3.47864 7.47968C2.84626 6.82222 2.4244 5.93451 2.4244 4.94817C2.4244 2.87692 4.21643 1.20031 6.43025 1.20031C7.44916 1.20031 8.36296 1.56195 9.06568 2.15359C9.83874 1.56194 10.7876 1.23306 11.8415 1.23306C12.9661 1.23306 13.985 1.62751 14.7581 2.25216C15.4608 1.5947 16.4447 1.20001 17.5339 1.20001C19.7478 1.20001 21.5398 2.87663 21.5398 4.94788C21.5398 5.90116 21.1532 6.78887 20.4855 7.47939C20.3451 7.67661 20.3098 7.87383 20.3098 8.07104C20.3098 8.20244 20.3801 8.33407 20.4855 8.43268C21.1533 8.89294 21.7506 9.48483 22.2425 10.2409C23.3322 11.7536 24 13.726 24 15.5014L24 15.5015ZM22.6999 15.8632C22.735 15.7645 22.735 15.6329 22.735 15.5015C22.735 11.2934 19.713 8.69617 17.5695 8.69617C16.9018 8.69617 16.1288 8.95921 15.391 9.41945C16.0234 9.8797 16.5856 10.5044 17.1129 11.2277C17.3589 11.5565 17.5697 11.8851 17.7452 12.2798C20.0645 12.444 21.9618 13.8906 22.6999 15.8633L22.6999 15.8632ZM19.7483 6.42774C20.0645 6.00028 20.2753 5.50721 20.2753 4.94838C20.2753 3.53483 19.0453 2.38405 17.5344 2.38405C16.7614 2.38405 16.0937 2.67988 15.6017 3.14014C16.0233 3.7976 16.3045 4.55369 16.3045 5.34283C16.3045 5.93448 16.164 6.46056 15.953 6.98663C16.4098 7.31549 16.9719 7.47968 17.5695 7.47968C18.3425 7.47968 19.0453 7.18385 19.5372 6.6906C19.5725 6.62501 19.6779 6.5264 19.7483 6.42779L19.7483 6.42774ZM14.7936 5.27696C14.7936 3.73179 13.4583 2.48239 11.8067 2.48239C10.1551 2.48239 8.81976 3.73173 8.81976 5.27696C8.81976 6.82214 10.1551 8.07154 11.8067 8.07154C13.4936 8.07154 14.7936 6.8222 14.7936 5.27696ZM7.41445 5.37558C7.41445 4.48786 7.69559 3.69896 8.1875 3.04126C7.69557 2.64682 7.09826 2.41656 6.39548 2.41656C4.88463 2.41656 3.65463 3.56734 3.65463 4.98089C3.65463 5.53975 3.83038 6.03304 4.18162 6.46025C4.28702 6.55886 4.35736 6.65747 4.42771 6.75608C4.91964 7.24913 5.62238 7.54516 6.39543 7.54516C6.92242 7.54516 7.41434 7.41376 7.80087 7.15072C7.59007 6.59186 7.41433 6.00018 7.41433 5.37553L7.41445 5.37558ZM6.60631 11.2275C7.1333 10.4384 7.7659 9.81395 8.46868 9.32069C7.80097 8.89324 7.06324 8.66323 6.43062 8.66323C4.28714 8.66323 1.26518 11.2603 1.26518 15.4686C1.26518 15.9946 1.44093 16.4219 1.86251 16.7835C2.42479 17.2765 3.54912 17.6054 4.81413 17.7368C4.74378 17.5065 4.74378 17.2765 4.74378 17.0135C4.74403 15.0739 5.41174 12.904 6.6064 11.2274L6.60631 11.2275Z"/>
                    <path d="M17.2043 19.9444C16.7349 19.9065 15.6001 19.7926 15.6001 19.1468C15.6001 18.843 15.8348 18.5773 16.1088 18.5773C16.3435 18.5773 16.6956 18.8811 17.2043 18.8811V17.8179C16.0305 17.4762 15.6394 17.0584 15.6394 16.4508C15.6394 15.5393 16.3435 14.9698 17.2043 14.8938V14.59C17.2043 14.476 17.2826 14.4 17.4 14.4C17.5563 14.4 17.5956 14.476 17.5956 14.59V14.8938C18.026 14.8938 18.8478 15.0456 18.8478 15.6154C18.8478 15.8813 18.6521 16.1091 18.3783 16.1091C18.1043 16.1091 17.9089 15.8432 17.5959 15.8432V16.7925C18.3783 17.0203 19.2001 17.362 19.2001 18.3113C19.2001 19.3746 18.3003 19.8684 17.5959 19.9063V20.2101C17.5959 20.324 17.5176 20.4 17.4003 20.4C17.2439 20.4 17.2046 20.324 17.2046 20.2101L17.2043 19.9444ZM17.2043 15.8432C16.9696 15.8811 16.8129 16.0331 16.8129 16.2988C16.8129 16.5266 17.0086 16.6405 17.2043 16.6787V15.8432ZM17.6346 18.8812C17.8694 18.8812 18.026 18.6534 18.026 18.4256C18.026 18.1218 17.8696 18.0079 17.6346 17.9319V18.8812Z" />
                  </svg>
                </span>
              </div>
              <div class="block">
                <p>{{__('Partner balance')}}, USDT</p>
                <span>{{$primNum(fund.balancePartner)}}</span>
              </div>
            </li>
            <li v-on:click="updateWallet(4)" :class="(form.wallet== 4) ? 'active' : ''">
              <div class="img">
                <span>
                  <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.9669 11.7594V7.27524C23.9669 6.87171 23.8065 6.48446 23.5212 6.19919C23.2357 5.91386 22.8486 5.75353 22.4452 5.75353H20.6089V1.88826C20.6089 1.40932 20.3833 0.958228 20.0002 0.670866C19.617 0.383503 19.1209 0.293376 18.6609 0.427434L11.2859 2.58819C10.2451 1.16042 8.64794 0.240825 6.89049 0.0576367C5.13328 -0.125563 3.38052 0.445091 2.06783 1.62761C0.755073 2.8101 0.00533432 4.49399 0.00463867 6.26077V19.1042C0.00463867 19.5078 0.164963 19.8948 0.450291 20.1803C0.735844 20.4656 1.12287 20.626 1.52635 20.626H22.4452C22.8487 20.626 23.2357 20.4656 23.5212 20.1803C23.8066 19.8948 23.9669 19.5077 23.9669 19.1042L23.9669 11.7594ZM22.9524 14.1231H21.5321C21.2003 14.1231 20.8939 13.9462 20.7282 13.6588C20.5624 13.3717 20.5624 13.0177 20.7282 12.7306C20.894 12.4435 21.2004 12.2666 21.5321 12.2666H22.9524V14.1231ZM18.9451 1.40133C19.0982 1.3531 19.2651 1.38344 19.3915 1.4824C19.5192 1.57818 19.5944 1.72855 19.5944 1.88819V5.75347H12.4929C12.4277 4.96205 12.2108 4.19051 11.8539 3.48106L18.9451 1.40133ZM6.24368 1.02587C7.63273 1.02316 8.96583 1.57252 9.94954 2.55329C10.9332 3.53382 11.4869 4.86512 11.4887 6.25393C11.4905 7.64298 10.9403 8.97561 9.95905 9.95863C8.97783 10.9416 7.64629 11.4946 6.25731 11.4956C4.86826 11.4965 3.53609 10.9453 2.55348 9.96338C1.57116 8.9817 1.01904 7.64976 1.01904 6.26072C1.01904 4.87417 1.56932 3.54425 2.54873 2.5628C3.52832 1.58135 4.85713 1.0286 6.24368 1.02587ZM22.4756 19.6015H1.526C1.24589 19.6015 1.01875 19.3744 1.01875 19.0943V9.6595C1.96983 11.1262 3.49273 12.1267 5.21667 12.4172C6.94038 12.7077 8.70716 12.2618 10.0865 11.1878C11.4658 10.114 12.3315 8.51069 12.4723 6.76819H22.4451C22.5796 6.76819 22.7087 6.82164 22.8038 6.91674C22.8989 7.01185 22.9523 7.14093 22.9523 7.27544V11.2524H21.532C20.8379 11.2524 20.1967 11.6226 19.8495 12.2236C19.5024 12.8248 19.5024 13.5654 19.8495 14.1663C20.1967 14.7676 20.838 15.1378 21.532 15.1378H22.9523V19.1147C22.9467 19.3908 22.7213 19.6118 22.4451 19.6118L22.4756 19.6015Z"/>
                    <path d="M4.6301 8.94955C4.72544 9.04557 4.85497 9.09969 4.99016 9.09969C5.12557 9.09969 5.2551 9.04557 5.35044 8.94955L10.0171 4.28289C10.2159 4.08406 10.2159 3.7616 10.0171 3.56254C9.81805 3.36372 9.49559 3.36372 9.29675 3.56254L4.98516 7.87413L3.2098 6.08857C3.01097 5.88975 2.68851 5.88975 2.48945 6.08857C2.29063 6.28762 2.29063 6.61008 2.48945 6.80892L4.6301 8.94955Z" />
                  </svg>
                </span>
              </div>
              <div class="block">
                <p>{{__('Checking account')}}, USDT</p>
                <span>{{$primNum(fund.balanceСurrent)}}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="amount">
          <div class="block">
            <p>{{__('Enter amount')}}</p>
            <p>{{__('Available:')}}
              <span v-if="form.wallet== 1">{{$primNum(fund.balance)}} USDT</span>
              <span v-else-if="form.wallet== 3">{{$primNum(fund.balancePartner)}} USDT</span>
              <span v-else-if="form.wallet== 4">{{$primNum(fund.balanceСurrent)}} USDT</span>
            </p>
          </div>
          <div class="input-block">
            <p>USDT</p>
            <InputLabelTextDefault
                  type="number"
                  v-model="form.amount"
                  v-bind:errors="formValidate.amount"
                  @input="updateValidate('amount')"
            ></InputLabelTextDefault>
          </div>
        </div>
        <div class="period">
          <div class="text">
            <p>{{__('Choose an investment period')}}</p>
            <a href="#">{{__('To learn more')}}</a>
          </div>
          <v-radio-group v-model="form.period" row>
            <v-radio :label="__('1 year')" value="1"></v-radio>
            <v-radio :label="__('2 years')" value="2"></v-radio>
            <v-radio :label="__('3 years')" value="3"></v-radio>
          </v-radio-group>
        </div>
        <div class="btn-block">
          <v-btn class="btn-green-new" v-on:click="onSubmit" :loading="submitDisabled">{{__('Invest in a fund')}}</v-btn>
        </div>
      </div>
      <div class="right">
        <div>
          <p class="text">{{__('Fund profit')}}</p>
          <p class="percent">{{__('5-12%')}}</p>
          <p class="month">{{__('per month')}}</p>
        </div>
        <img src="/newfrontend/images/fund-right.svg" alt="">
      </div>
    </div>

    <div class="body-fund">
      <h2>{{__('Working funds in the fund')}}</h2>
      <ul>
        <div class="block">
          <li class="list-name">
            <div class="summ">
              <p>{{__('Sum')}}</p>
            </div>
            <div class="date">
              <p>{{__('Date of entry')}}</p>
            </div>
            <div class="profit">
              <p>{{__('Profit')}}</p>
            </div>
            <div class="percent">
              <p>{{__('Ratio')}}</p>
            </div>
            <div class="period">
              <p>{{__('Period')}}</p>
            </div>
            <div class="block-btn">

            </div>
          </li>
        </div>
        <div class="block">
          <li class="list" v-for="(pool, key) in fund.pool" :key="key">
            <div class="summ">
              <span class="mob">{{__('Sum')}}</span>
              <p>{{$primNum(pool.amount)}} USDT</p>
            </div>
            <div class="date">
              <span class="mob">{{__('Date of entry')}}</span>
              <p>{{pool.date_start | formatYMD}}</p>
            </div>
            <div class="profit">
              <span class="mob">{{__('Profit')}}</span>
              <p class="plus">{{$primNum(pool.total_profit)}} USDT</p>
            </div>
            <div class="percent">
              <span class="mob">{{__('Ratio')}}</span>
              <p v-if="pool.period== 1">40/60</p>
              <p v-else-if="pool.period== 2">50/50</p>
              <p v-else-if="pool.period== 3">60/40</p>
            </div>
            <div class="period">
              <span class="mob">{{__('Period')}}</span>
              <p class="bonus" v-if="pool.bonus">{{__("bonus")}}</p>
              <p v-else>{{pool.period}} {{__('year')}}</p>
            </div>
            <div class="block-btn" v-if="pool.active && pool.finish">
                <v-btn v-on:click="reinvest= pool.id">{{__('Reinvest')}}</v-btn>
                <v-btn v-on:click="witdraw= pool.id">{{__('withdraw')}}</v-btn>
            </div>
          </li>
        </div>
      </ul>
    </div>


    <ModalDefault v-if="reinvest" v-bind:close="false" width="470">
      <div class="window-site withdraw-window">
        <div class="top">
          <h1>{{__('Reinvest')}}</h1>
          <p>{{__('Check the data correctness and confirm the application application')}}</p>
        </div>
        <div class="withdraw-btn">
          <v-btn class="btn-white" v-on:click="modalCancel" :loading="submitDisabled">{{__('Cancel')}}</v-btn>
          <v-btn class="btn-site" v-on:click="onSubmitPlan" :loading="submitDisabled">{{__('Confirm the output')}}</v-btn>
        </div>
      </div>
    </ModalDefault>

    <ModalDefault v-else-if="witdraw" v-bind:close="false" width="470">
      <div class="window-site withdraw-window">
        <div class="top">
          <h1>{{__('Withdraw')}}</h1>
          <p>{{__('Check the data correctness and confirm the application application')}}</p>
        </div>
        <div class="withdraw-btn">
          <v-btn class="btn-white" v-on:click="modalCancel" :loading="submitDisabled">{{__('Cancel')}}</v-btn>
          <v-btn class="btn-site" v-on:click="onSubmitPlan" :loading="submitDisabled">{{__('Confirm the output')}}</v-btn>
        </div>
      </div>
    </ModalDefault>
  </div>
  <div class="loading" v-else>
    <loaderMc></loaderMc>
    {{__('Loading')}}
  </div>
</template>

<script>
import loaderMc from "../SvgComponents/loaderMc";
import InputLabelTextDefault from "../modules/InputLabelTextDefault";
import ModalDefault from "../modules/ModalDefault";
import {decimal, maxValue, minValue, numeric, required} from "vuelidate/lib/validators";
export default {
  name: 'fund',
  data () {
    return {
      submitDisabled: null,
      radioGroup: 1,
      form: {
          amount: null,
          wallet: 1,
          period: "1",
      },
      formValidate: {
          wallet: null,
          amount: null,
          period: null,
      },
      fund: null,
      reinvest: null,
      witdraw: null,
    }
  },

  methods:{
      updateValidate: function(type) {
          this.formValidate= this.$changeValidate(this.formValidate, this.$v.form[type], type);
      },
      modalCancel() {
          this.reinvest= null;
          this.witdraw= null;
      },
      onSubmit() {
          let valid= this.$v.form;
          if(valid.$invalid) {
              let massages= {
                  'amount': [],
                  'wallet': [],
                  'period': [],
              };
              this.formValidate= this.$formValidate(massages, valid);
          } else {
              this.submitDisabled = true;
              let data= this.$cleanObject(this.form);

              this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/fund/invest', data)
                  .then(response => {
                      return response.json()
                  })
                  .then((response) => {
                      this.submitDisabled = false;
                      this.fund = response.data;

                      this.$store.dispatch('asyncUpdateTime', Date.now());
                      this.$http.get('ajax/user_info')
                          .then(response => {
                              return response.json()
                          })
                          .then((response) => {
                              this.$store.dispatch('asyncResp', response.resp_tickets);
                              let portfolio = response.data;
                              // if(portfolio.lang) {
                              //     this.$store.dispatch("asyncLanguage", portfolio.lang);
                              // }
                              this.$store.dispatch('asyncPortfolio', portfolio);
                              this.$store.dispatch('asyncPayments', portfolio.payment);
                          }).catch((err) => {
                          this.httpHandler(err);
                      });
                  }).catch((err) => {
                      this.submitDisabled = false;
                      this.httpHandler(err);
                  });
          }
      },
      updateWallet(wallet) {
          this.form.wallet= wallet;
          this.updateValidate('amount');
      },
      onSubmitPlan() {
          let plan_id,
              route;

          if(this.reinvest) {
              plan_id= this.reinvest;
              route= 'reinvest';
          } else {
              plan_id= this.witdraw;
              route= 'witdraw';
          }

          this.submitDisabled = true;

          this.$http[(process.env.NODE_ENV === 'production') ? 'post' : 'get']('ajax/fund/'+route, {'plan_id': plan_id})
              .then(response => {
                  return response.json()
              })
              .then((response) => {
                  this.submitDisabled = false;
                  this.fund = response.data;

                  this.modalCancel();
              }).catch((err) => {
                  this.submitDisabled = false;
                  this.httpHandler(err);

                  this.modalCancel();
              });
      }
  },
  props: {

  },

  validations() {
      let wallet= this.form.wallet;
      let max= 0;

      if(wallet== 1) {
          max= this.fund.balance;
      } else if(wallet== 3) {
          max= this.fund.balancePartner;
      } else if(wallet== 4) {
          max= this.fund.balanceСurrent;
      }

      return {
          form: {
              wallet: {
                  required,
                  decimal
              },
              amount: {
                  required,
                  decimal,
                  minValue: minValue((this.form.wallet== 4) ? 20 : 50),
                  // limit: maxValue((200/this.payment.course_usd)- ((this.portfolio.sum_invest) ? this.portfolio.sum_invest : 0))
                  maxValue: maxValue(this.$primNum(max))
                  // maxValue: maxValue(this.payment.max_replenish*this.payment.course_usd)
              },
              period: {
                  required,
                  numeric
              },
          }
      }
  },
  created () {

      this.$http.get('ajax/fund')
          .then(response => {
              return response.json()
          })
          .then((response) => {
              this.fund = response.data;
          }).catch((err) => {
          this.httpHandler(err);
      });
  },
  computed: {
      portfolio() {
          return this.$store.state.auth.portfolio;
      },
  },
  components: {
    InputLabelTextDefault,
    loaderMc,
    ModalDefault,
  }
}
</script>

<style scoped>

</style>
